module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "_idGenObjectStyleOverride-1"
  }, [_c('p', {
    staticClass: "CHAPTER1",
    attrs: {
      "id": "uCFpxKRKYg6lvk9gkKj5yTD"
    }
  }, [_vm._v("Chapter Two")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("The Greyhound’s Michelins groaned over the roadway scarred with jagged potholes. But Angus and Cassie didn’t let it interfere with their game. Despite the jostling, the plastic markers held firm, their bottoms magnetized to the shimmering surface of the game board. But the cards were a different story. Using an index finger, Angus pressed down on the ‘Time of Your Life’ deck while Cassie did the same to the ‘Pay the Piper’ pile, containing the cards tenaciously inside their holding trays.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Angus picked up the dice.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Cmon ‘ten’,” he whispered, releasing the cubes which rolled across the board and settled as a ‘six’ and a ‘three’.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Close enough!” he said, counting off nine squares on his trek along the path that meandered around and about the game’s playing field: a map of the City of New York featuring its landmarks.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“That puts me on top o’ the town at the Empire Freakin’ State Building!” He slammed down his blue marker on the prized square.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("His action activated a tiny speaker embedded under the skyscraper’s icon, and music sounded, replete with vocals: Francis Albert Sinatra’s rendition of New York, New York.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("He reached for a ‘Time of Your Life’ card.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Well, lookee here. I’ve just been awarded a three-hour shopping spree at Paragon Sports. And it entitles me to disregard the next ‘Pay the Piper Card’.” He reached in his pocket and ran a finger across the blade.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Touching the weapon aroused him.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Cassie sneered. She palmed the dice and blew into her fist.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Mama needs a new pair o’ shoes,” she said, letting loose the dice which skittered across the board settling as a ‘one’ and a ‘two’. “Shit! I gotta pay the piper!”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Cassie counted off the three squares. Angus handed her the ‘Pay the Piper’ card.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Read it and weep,” he said.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Cassie’s lower lip jutted forward.")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH-CENTER"
  }, [_vm._v("You’ve been caught shoplifting at Macy’s.")]), _vm._v(" "), _c('p', {
    staticClass: "Perfect-Center"
  }, [_vm._v("Lose a turn.")]), _vm._v(" "), _c('p', {
    staticClass: "FIRSTPARAGRAPH"
  }, [_vm._v("“Hellhole of a city,” she muttered.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Lemme show ya how it’s done.” Angus reached for the dice for the first of his next two turns, his and the one she had lost.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("The cubes clattered across the board. A ‘five’ and a ‘six’.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("He eyed the board and counted off eleven squares.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“I’m halfway through their beloved Kings County! C’mon on ‘Twelve’!” He rattled the cubes in his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Cassie groaned as a ‘double six’ rolled to a stop.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Yes!” he cheered, reaching for his marker.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Hold it!” she said, gesturing at the Greyhound’s rain-slicked window. The bus had entered the terminal and was coming to a stop. “Remember what we said. Once the bus arrives, we set it all in motion at the tourist traps closest to our pieces.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("Angus eyed the board and grinned.")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“Well, then, Coney Island’s my next stop.”")]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_vm._v("“And me?” said Cassie. “I get to start settling the score at the American Museum of Natural History.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4adee352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/SR_002.vue
// module id = 81
// module chunks = 0